export const SUBMIT_CREATE_USER_GENERATED_CONTENT_CLICK =
  'w:Submit:AddUserGeneratedContent:click';
export const SUBMIT_CREATE_USER_GENERATED_CONTENT_CANCEL_CLICK =
  'w:Submit:AddUserGeneratedContent:Cancel:click';
